import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { Title } from '../titles';
import { TextBlock } from '../text';
import { LineSeparator } from '../separators';

import { MarginBottom20, MarginTop20 } from '../margins';
import { FontSize18 } from '../fonts';
import DefaultCircleTickedIcon from '../CircleTickedIcon';

import { Generic } from '../../i18n';

const FormSection = styled.div`
    ${MarginBottom20};
`;

const Heading = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${MarginBottom20};
`;

const CircleTickedIcon = styled(DefaultCircleTickedIcon)`
    margin-right: 25px;
`;

const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: left;
`;

const TitlePersonalData = styled(Title)`
    text-transform: uppercase;
`;

const SubtitlePersonalData = styled(TextBlock)`
    ${FontSize18};
    ${MarginTop20};
    margin-bottom: 40px;
    text-align: left;
`;

const EditLabel = styled(Link)`
    font-size: 10px;
    color: ${props => props.theme.color.darkBlue};
    text-transform: uppercase;
    text-decoration: underline;
`;

export default ({
    title = '',
    subtitle = '',
    isActive = false,
    backpath = '/'
}) => (
    <FormSection>
        <Heading>
            <TitleWrapper>
                { !isActive && <CircleTickedIcon /> }
                <TitlePersonalData>{title}</TitlePersonalData>
            </TitleWrapper>

            { !isActive && <EditLabel to={backpath}>{Generic.edit}</EditLabel> }
        </Heading>
        
        <LineSeparator />

        { isActive && <SubtitlePersonalData>{subtitle}</SubtitlePersonalData> }
    </FormSection>
);